<template>
	<div class="h-screen flex flex-col overflow-x-hidden">
		<div style="max-height: 23vh flex-grow-0">
			<Nav />
			<PickHistory />
		</div>
		<CommissionerSection :room_id="room_id" />
		<div
			class="lg:container mx-auto flex md:flex-row flex-col items-stretch flex-grow w-full"
		>
			<div class="flex-grow h-full" style="min-height: 50vh">
				<PlayerQueue :room_id="room_id" />
			</div>
			<div class="flex-grow-0" style="min-height: 17vh">
				<UserRoster />
			</div>
		</div>
		<DraftControl :room_id="room_id" />
	</div>
</template>

<script>
import CommissionerSection from '@/components/CommissionerSection.vue';
import PickHistory from '@/components/room/PickHistory.vue';
import PlayerQueue from '@/components/room/PlayerQueue.vue';
import UserRoster from '@/components/room/UserRoster.vue';
import DraftControl from '@/components/room/DraftControl.vue';
import Nav from '@/components/room/Nav.vue';
import { mapState } from 'vuex';

export default {
	computed: {
		...mapState(['current_picker', 'current_round']),
		...mapState({
			all_users: state => state.room.all_users,
			current_user: state => state.user.name,
			room_id: state => state.room.id,
		}),
	},
	components: {
		CommissionerSection,
		PickHistory,
		PlayerQueue,
		UserRoster,
		DraftControl,
		Nav,
	},
	created() {
		this.$store.dispatch('get_room');
	},
	channels: {
		RoomChannel: {
			connected() {},
			received(data) {
				switch (data.action) {
					case 'CONFIRMED_PICK':
						this.$store.commit(
							'player_picked',
							data.pick_data
						);
						this.$store.commit(
							'set_current_picker',
							data.current_picker
						);
						this.$store.commit(
							'set_current_round',
							data.current_round
						);
						break;
					case 'DRAFT_START':
						this.start_draft(data);
						break;
					case 'DRAFT_RESTART':
						this.restart_draft(data);
						break;
				}
			},
		},
	},
	mounted() {
		this.$cable.subscribe({
			channel: 'RoomChannel',
			room_id: this.room_id,
		});
	},
	methods: {
		start_draft(draft_data) {
			this.$store.commit(
				'set_current_picker',
				draft_data.current_picker
			);
			this.$store.commit(
				'set_current_round',
				draft_data.current_round
			);
		},
		restart_draft(draft_data) {
			this.$store.dispatch('restart_draft');
			this.$store.commit(
				'set_current_picker',
				draft_data.current_picker
			);
			this.$store.commit(
				'set_current_round',
				draft_data.current_round
			);
		},
	},
};
</script>
